<template>
    <div>
        <RemoteTable ref="table" :form="form" :table="table">
            <template #expand="{row}">
                <el-form label-position="left" class="table-expand">
                    <el-form-item label="部门名称">{{$root.getCustomerName(row.code)}}</el-form-item>
<!--                    <el-form-item label="短信通道">{{getChannelName(row.channel)}}</el-form-item>-->
                    <el-form-item label="推送时间">{{row.pushTime}}</el-form-item>
                </el-form>
            </template>

            <template #default="{row, property}">
                <template v-if="property === 'code'">
                    {{$root.getBusinessName(row.code)}}
                </template>
            </template>
        </RemoteTable>
    </div>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'

    export default {
        components: {
            RemoteTable
        },
        data() {
            return {
                form: {
                    configs: [
                        {label: "业务", name: "code", type: "cascade", op: "beginwith", value: ""},
                        {label: "手机号", name: "mobile", type: "input", value: ""},
                        // {label: "通道", name: "channel", type: "select", value: "", options: []},
                        {label: "时间", name: "sendTime", type: "datetimerange", op: "between", value: []},
                        {label: "状态", name: "status", type: "select", value: "", url: "/dict/list/smsup/status"},
                    ],
                    tools: [
                      this.$root.couldExport ? {
                            label: "导出",
                            click: () => {
                              this.$confirm("确认进行导出操作？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: 'warning'
                              }).then(() => {
                                this.$axios.post('/uplog/download', this.$refs.table.getQueryInfo()).then(response => {
                                  if (response.success) {
                                    this.$message("文件生成中，请稍候前往下载管理");
                                  } else {
                                    this.$message.error(response['message']);
                                  }
                                });
                              });
                            }
                        }: {}
                    ]
                },
                table: {
                    urlPrefix: "/smsup",
                    expand: true,
                    columns: [
                        {label: "业务名称", name: "code"},
                        {label: "手机号", name: "mobile", width: 110},
                        {label: "内容", name: "content", width: 200},
                        {label: "发送时间", name: "sendTime", width: 150},
                        {label: "状态", name: "status", width: 80},
                    ],
                    defaultSort: {
                        prop: "id",
                        order: "descending"
                    }
                },
                channels: []
            }
        },
        mounted() {
            // let options = [];
            // this.$axios.post("/channel/list").then(results => {
            //     results.forEach(result => {
            //         options.push({value: result.code, label: result.name});
            //     });
            //
            //     this.$set(this.form.configs[2], 'options', options);
            //     this.channels = options;
            // });
        },
        methods: {
            getChannelName(val) {
                let name = "";
                this.channels.forEach(option => {
                    if (val === option.value) {
                        name = option.label;
                        return false;
                    }
                });
                return name;
            }
        }
    }
</script>

<style scoped>
    >>> .table-expand label {
        color: #99a9bf;
    }

    >>> .table-expand .el-form-item {
        margin-bottom: 0;
    }

    >>> .table-expand .el-form-item * {
        line-height: 30px;
    }
</style>